import axios from 'axios';

const BASE_URL = 'https://pixabay.com/api/';
const PER_PAGE = 15;
const API_KEY = import.meta.env.VITE_PIXABAY_KEY;

export async function getImagesByQuery(query, page) {
  const { data } = await axios.get(BASE_URL, {
    params: {
      key: API_KEY,
      q: query,
      image_type: 'photo',
      orientation: 'horizontal',
      safesearch: true,
      page,
      per_page: PER_PAGE,
    },
  });

  return data;
}
